import { createElement } from 'react';

interface ChangeEvent {
	nativeEvent: CustomSelectEvent;
}

export interface CustomSelectEvent {
	detail: {
		value: string;
	};
}

interface SelectProps {
	options?: { label: string; value: string | number }[];
	value?: string | number;
	onChange?: (event: CustomSelectEvent) => void;
	children?: React.ReactNode;
}

function FormaSelectNative({
	value,
	onChange,
	children,
	disabled,
}: SelectProps & { disabled?: boolean }) {
	return createElement('forma-select-native', { value, onChange, disabled }, children);
}

export const Select = ({
	options,
	value,
	onChange,
	disabled,
}: SelectProps & { disabled?: boolean }) => {
	return (
		<FormaSelectNative
			value={value}
			disabled={disabled}
			onChange={(e: unknown) =>
				onChange && onChange((e as ChangeEvent).nativeEvent as CustomSelectEvent)
			}
		>
			{options?.map((option) => (
				<option key={option.value} value={option.value}>
					{option.label}
				</option>
			))}
		</FormaSelectNative>
	);
};
